import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage11.module.css"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/shivaShakti.json";

export default function LaymanPage11() {
  return (
    <>
       <Common_html BlockData={BlockData} />
    </>
  )
}
